// frontend-public/src/services/bookingService.js
// ============================================================
// Online Web Booking — public API client（Plan 090 / 086 Phase 1a.0）
//
// 包 apiService.apiRequest（isTest=true → 不帶 JWT，純公開呼叫）打三個公開端點：
//   GET  /api/public/r/:slug
//   GET  /api/public/r/:slug/availability?date&partySize
//   POST /api/public/r/:slug/reservations
//
// 非 2xx 時 apiRequest 會 throw，error.response.data 內含 { error, message, existing? }，
// 由 BookingPage 對應成中文訊息。
// ============================================================

import { apiRequest } from './apiService';

const getRestaurant = async (slug) => {
  const res = await apiRequest('get', `public/r/${encodeURIComponent(slug)}`, null, true);
  return res.data;
};

const getAvailability = async (slug, date, partySize) => {
  const qs = `date=${encodeURIComponent(date)}&partySize=${encodeURIComponent(partySize)}`;
  const res = await apiRequest('get', `public/r/${encodeURIComponent(slug)}/availability?${qs}`, null, true);
  return res.data;
};

const createReservation = async (slug, payload) => {
  const res = await apiRequest('post', `public/r/${encodeURIComponent(slug)}/reservations`, payload, true);
  return res.data;
};

const bookingService = { getRestaurant, getAvailability, createReservation };
export default bookingService;
export { getRestaurant, getAvailability, createReservation };
